var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.doesContainCourse
    ? _c(
        "article",
        { staticClass: "nti-checkout-participants" },
        [
          _c("h1", { staticClass: "nti-webshop-checkout__title" }, [
            _vm._v(_vm._s(_vm.verifyLabel("participantsHeader"))),
          ]),
          _vm._v(" "),
          _c("p", {
            staticClass: "nti-webshop-checkout__title-paragraph",
            domProps: {
              innerHTML: _vm._s(
                _vm.verifyLabel("courseParticipantsSubTitleLabel")
              ),
            },
          }),
          _vm._v(" "),
          _vm._l(_vm.form, function (course, courseIndex) {
            return [
              _c(
                "section",
                {
                  key: courseIndex,
                  staticClass:
                    "nti-checkout-participants__container toggle-box",
                },
                [
                  _c("div", { attrs: { "data-target": `#${course.code}` } }, [
                    _c("input", {
                      attrs: { name: course.hiddenFieldname, type: "hidden" },
                      domProps: { value: course.code },
                    }),
                    _vm._v(" "),
                    _c(
                      "h3",
                      {
                        staticClass:
                          "nti-checkout-participants__course-info__title",
                      },
                      [_vm._v(_vm._s(course.courseTitle))]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "nti-checkout-participants__course-info" },
                      [
                        _c(
                          "div",
                          {
                            staticClass:
                              "nti-checkout-participants__course-info__container",
                          },
                          [
                            _c(
                              "p",
                              {
                                staticClass:
                                  "nti-checkout-participants__course-info__label",
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.verifyLabel(
                                      "courseParticipantsDateLabel"
                                    )
                                  )
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "p",
                              {
                                staticClass:
                                  "nti-checkout-participants__course-info__label",
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.verifyLabel(
                                      "courseParticipantsLocationLabel"
                                    )
                                  )
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "p",
                              {
                                staticClass:
                                  "nti-checkout-participants__course-info__label",
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.verifyLabel(
                                      "courseParticipantsDurationLabel"
                                    )
                                  )
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c("p", {
                              staticClass:
                                "nti-checkout-participants__course-info__label",
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.verifyLabel(
                                    "courseParticipantsAmountLabel"
                                  )
                                ),
                              },
                            }),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "nti-checkout-participants__course-info__container",
                          },
                          [
                            _c("p", [_vm._v(_vm._s(course.date))]),
                            _vm._v(" "),
                            _c("p", [_vm._v(_vm._s(course.location))]),
                            _vm._v(" "),
                            _c("p", [_vm._v(_vm._s(course.duration))]),
                            _vm._v(" "),
                            _c("p", [_vm._v(_vm._s(course.participantCount))]),
                          ]
                        ),
                      ]
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "toggle-box__target collapse show",
                      attrs: {
                        id: course.code,
                        "data-js": "toggle-box-target",
                      },
                    },
                    [
                      _vm._l(
                        course.participants,
                        function (participant, participantIndex) {
                          return [
                            _c(
                              "div",
                              {
                                key: participantIndex,
                                staticClass:
                                  "add-participants__participant nti-checkout-participants__participant__wrapper",
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "nti-checkout-participants__participant__container",
                                  },
                                  [
                                    _c("div", {
                                      staticClass:
                                        "nti-checkout-participants__participant__line",
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "nti-checkout-participants__participant",
                                      },
                                      [
                                        _c("h4", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.verifyLabel(
                                                "participantsNumberText"
                                              )
                                            ) +
                                              " " +
                                              _vm._s(participantIndex + 1)
                                          ),
                                        ]),
                                      ]
                                    ),
                                  ]
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                key: "field" + participantIndex,
                                staticClass:
                                  "nti-checkout-participants__field-container",
                              },
                              [
                                _vm._l(participant, function (field) {
                                  return [
                                    _c(
                                      "div",
                                      {
                                        key: field.displayName,
                                        staticClass:
                                          "form-group nti-checkout-billing__form-group",
                                      },
                                      [
                                        _c("label", [
                                          _vm._v(_vm._s(field.displayName)),
                                        ]),
                                        _vm._v(" "),
                                        field.type === "checkbox"
                                          ? _c("input", {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value: field.value,
                                                  expression: "field.value",
                                                },
                                              ],
                                              staticClass: "form-control",
                                              class:
                                                _vm.displayValidationResult(
                                                  field
                                                ),
                                              attrs: {
                                                disabled: _vm.disableField,
                                                name: field.name,
                                                required: field.required,
                                                type: "checkbox",
                                              },
                                              domProps: {
                                                checked: Array.isArray(
                                                  field.value
                                                )
                                                  ? _vm._i(field.value, null) >
                                                    -1
                                                  : field.value,
                                              },
                                              on: {
                                                change: function ($event) {
                                                  var $$a = field.value,
                                                    $$el = $event.target,
                                                    $$c = $$el.checked
                                                      ? true
                                                      : false
                                                  if (Array.isArray($$a)) {
                                                    var $$v = null,
                                                      $$i = _vm._i($$a, $$v)
                                                    if ($$el.checked) {
                                                      $$i < 0 &&
                                                        _vm.$set(
                                                          field,
                                                          "value",
                                                          $$a.concat([$$v])
                                                        )
                                                    } else {
                                                      $$i > -1 &&
                                                        _vm.$set(
                                                          field,
                                                          "value",
                                                          $$a
                                                            .slice(0, $$i)
                                                            .concat(
                                                              $$a.slice($$i + 1)
                                                            )
                                                        )
                                                    }
                                                  } else {
                                                    _vm.$set(
                                                      field,
                                                      "value",
                                                      $$c
                                                    )
                                                  }
                                                },
                                              },
                                            })
                                          : field.type === "radio"
                                          ? _c("input", {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value: field.value,
                                                  expression: "field.value",
                                                },
                                              ],
                                              staticClass: "form-control",
                                              class:
                                                _vm.displayValidationResult(
                                                  field
                                                ),
                                              attrs: {
                                                disabled: _vm.disableField,
                                                name: field.name,
                                                required: field.required,
                                                type: "radio",
                                              },
                                              domProps: {
                                                checked: _vm._q(
                                                  field.value,
                                                  null
                                                ),
                                              },
                                              on: {
                                                change: function ($event) {
                                                  return _vm.$set(
                                                    field,
                                                    "value",
                                                    null
                                                  )
                                                },
                                              },
                                            })
                                          : _c("input", {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value: field.value,
                                                  expression: "field.value",
                                                },
                                              ],
                                              staticClass: "form-control",
                                              class:
                                                _vm.displayValidationResult(
                                                  field
                                                ),
                                              attrs: {
                                                disabled: _vm.disableField,
                                                name: field.name,
                                                required: field.required,
                                                type: field.type,
                                              },
                                              domProps: { value: field.value },
                                              on: {
                                                input: function ($event) {
                                                  if ($event.target.composing)
                                                    return
                                                  _vm.$set(
                                                    field,
                                                    "value",
                                                    $event.target.value
                                                  )
                                                },
                                              },
                                            }),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "invalid-feedback" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.verifyLabel(
                                                  "inputValidationErrorLabel"
                                                )
                                              )
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ]
                                }),
                              ],
                              2
                            ),
                          ]
                        }
                      ),
                    ],
                    2
                  ),
                ]
              ),
            ]
          }),
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }